<template>
    <div class="section-light contact" id="contact">
        <div class="container">
            <div class="columns is-multiline" data-aos="fade-in-up" data-aos-easing="linear">
                <div class="column is-12 about-me">
                    <h2 class="title has-text-centered section-title">
                        Get in touch
                    </h2>
                    <h3 class="title is-4 has-text-centered">Send me a mail through the form below or find my contact
                        info <a href="#about-me" >here</a>  </h3>

                </div>
                <div class="column is-8 is-offset-2">
                    <form
                            action="https://formspree.io/p.zimmermann55@gmail.com"
                            method="POST"
                    >
                        <div class="field">
                            <label class="label">Name</label>
                            <div class="control has-icons-left">
                                <input
                                        class="input"
                                        type="text"
                                        placeholder="Your Name"
                                        name="Name"
                                />
                                <span class="icon is-small is-left">
                                  <font-awesome-icon icon="envelope" />
                                </span>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Email</label>
                            <div class="control has-icons-left">
                                <input
                                        class="input"
                                        type="email"
                                        placeholder="mail@address.com"
                                        name="Email"
                                />
                                <span class="icon is-small is-left">
                                  <font-awesome-icon icon="user" />
                                </span>
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Message</label>
                            <div class="control">
                    <textarea
                            class="textarea"
                            placeholder="What can I help you with?"
                            name="Message"></textarea>
                            </div>
                        </div>
                        <div class="field">
                            <div class="control ">
                                <button class="button submit-button">
                                    Submit&nbsp;&nbsp;
                                    <i class="fas fa-paper-plane"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "GetInTouch"
    }
</script>

<style scoped>

</style>
